module.exports = __webpack_public_path__ + "img/chart-live.3b6c05d0.svg";